<template>
  <div>
    <VerificationEmail v-if="!emailVerified" />
    <div v-else class="wide-width">
      <div v-if="events.length && !isLoading">
        <EventCard v-for="event in events" :key="event.id" class="event-row" :name="event.attributes.name"
          :imageUrl="event.attributes.thumbnail ? event.attributes.thumbnail._url : noImageUrl"
          :desc="event.attributes.desc" :startDateTime="event.attributes.startDateTime" :slug="event.attributes.slug"
          :timezone="event.attributes.timezone" />
      </div>

      <div v-if="isLoading">
        <EventCard style="padding-bottom: 5rem;" :loading="true" />
        <EventCard style="padding-bottom: 5rem;" :loading="true" />
      </div>

      <div v-if="!isLoading && events.length === 0" class="center-wrapper">
        <p class="empty-dataset">No Upcoming Events</p>
      </div>
    </div>
  </div>
</template>

<script>
import EventCard from "../components/EventCard"
import VerificationEmail from '../components/VerificationEmail';
import DataService from "../services/DataService";
import { mapGetters } from "vuex";
import moment from 'moment';
import { setMetaTags } from '../helpers/utils';

const ds = DataService.getInstance();
const noImageUrl = '../images/no-image.jpg'

export default {
  name: "Events",
  components: {
    EventCard,
    VerificationEmail,
  },
  props: {
  },
  data () {
    return {
      isLoading: true,
      emailVerified: true,
      events: [],
    };
  },
  async created () {
    ga("set", "page", "/events.html");
    ga("send", "pageview");
    this.$store.dispatch("settings/getAppSettings");

    setMetaTags({ title: 'Playmas | Events' });
    this.emailVerified = await this.$paidutils.hasVerifiedEmail();
    if (!this.emailVerified) {
      this.isLoading = false
      return
    }

    await this.getEvents()

    if (this.events.length === 1) {
      // if we just have 1 event, go to that event page
      const slug = this.events[0].get('slug')
      this.$router.push(`/events/${slug}`);
    }

    this.isLoading = false;
  },
  methods: {
    async getEvents () {
      try {
        const events = await ds.getEvents();
        this.events = _.sortBy(events, (item) => _.isUndefined(item.get("sortOrder")) ? 0 : item.get("sortOrder"));
      } catch (err) {
        this.$bvToast.toast(err.message, {
          variant: "danger"
        });
      }
    }
  },
  computed: {
    ...mapGetters("settings", [
      "bandName"
    ]),
    noImageUrl () {
      return noImageUrl
    },
    eventName () {
      return this.event ? this.event.get('name') : null
    },
    eventDesc () {
      return this.event ? this.event.get('desc') : null
    },
    eventDate () {
      return this.event ? moment(this.event.get('eventDate')).format('ddd MMM Do, YYYY') : null
    },
    eventThumbUrl () {
      return (this.event && this.event.get('thumbnail')) ? this.event.get('thumbnail')._url : null
    }
  }
};

</script>

<style scoped>
.event-row {
  margin-bottom: 5rem;
}
</style>
